@for (item of items; track $index; let last = $last) {
    @if (item?.routerLink?.length) {
        <button
            class="btn btn-link btn-sm me-1"
            (click)="linkClicked($event, item)"
        >
            {{ item.name }}
        </button>
        @if (!last) {
            <span>, </span>
        }
    } @else if (item?.name) {
        <span [attr.data-cy]="'ref-cell-name-only'">
            {{ item.name }}{{ last ? '' : ', ' }}
        </span>
    }
}
